<template>
<ControlUnit
    :title="$t('control.panel.widget_images')"
    :tooltip="$t('control.panel.widget_images_description')"
  >
    <div class="input-input">
    <label class="input-input__unit">
      <span class="input-input__label">{{ $t('control.panel.widget_image_url') }}:</span>

      <input
        class="input-input__input"
        type="text"
        name="title-parameter"
        v-model="currentTitleImageUrl"
      >

    </label>

    </div>

   <div class="input-input">
    <label class="input-input__unit">
      <span class="input-input__label">{{ $t('control.panel.bot_avatar_url') }}:</span>

      <input
        class="input-input__input"
        type="text"
        name="sub-title-parameter"
        v-model="currentBotAvatarUrl"
      >
    </label>
    </div>

</ControlUnit>

</template>

<script>
import useStateController from './useStateController';
import ControlUnit from "@/views/Control/ControlPanel/ControlUnit/ControlUnit";
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
import useRouteController from "@/views/Control/ControlPanel/ControlUnit/useRouteController";
import {runAllWithData} from "@/helpers/functional";


export default {
  components: {
    ControlUnit,
  },


  setup() {

    const titleImageName = 'title-image-url';
    const botAvatarName = 'bot-avatar-url';
    const store = useStore();

    const currentTitleImageUrl = computed({
      get() {
        return store.state.control.titleImageUrl;
      }, set(val){
          changeHandler({
            type: titleImageName,
            value: val,
        })
      }
    });

    const currentBotAvatarUrl = computed({
      get() {
        return store.state.control.botAvatarImageUrl;
      }, set(val){
          changeHandler({
            type: botAvatarName,
            value: val,
        })
      }
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {

      changeControlHandler({
        type: titleImageName,
        value: getRouterQueryValue(titleImageName),
      });

      changeControlHandler({
        type: botAvatarName,
        value: getRouterQueryValue(botAvatarName),
      });
    });

    return {
      titleImageName,
      botAvatarName,
      currentTitleImageUrl,
      currentBotAvatarUrl,
      changeHandler,
    };
  },
};
</script>
